import { Component, Input, OnInit } from '@angular/core';
import { Product } from 'src/app/shared/models/product.interface';

@Component({
	selector: 'app-cancel-policy',
	templateUrl: './cancel-policy.component.html'
})
export class CancelPolicyComponent implements OnInit {

	@Input() cancelationType: number = 1;
	@Input() className: string = '';
	@Input() product: Product = null;

	constructor() { }

	ngOnInit(): void {
		// console.log('CancelPolicyComponent.ngOninit.cancelationType:', this.cancelationType);
		// console.log('CancelPolicyComponent.ngOninit.product:', this.product);
	}

}
